export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38')
];

export const server_loads = [0,2,3];

export const dictionary = {
		"/": [~4],
		"/@[user=user_slug]/collections": [~5,[2]],
		"/account": [7,[3]],
		"/account/billing": [~8,[3]],
		"/account/my-event-registrations": [~9,[3]],
		"/account/settings": [~10,[3]],
		"/account/team-access": [~11,[3]],
		"/admin/billing-log": [~12],
		"/all": [~13],
		"/analyze-font": [14],
		"/assets": [~15],
		"/book": [~16],
		"/book/[resource=entry_slug]": [~17],
		"/calendar": [~18],
		"/login": [~19],
		"/login/confirm/[code]": [~20],
		"/logout": [~21],
		"/messages": [~22],
		"/new/media": [~24],
		"/new/[type]": [~23],
		"/playground/buttons": [25],
		"/playground/inputs": [26],
		"/playground/markdown": [27],
		"/playground/popover": [28],
		"/playground/search-select": [29],
		"/playground/toast": [30],
		"/posters": [~31],
		"/pricing-and-capacity": [~32],
		"/settings": [~33],
		"/signature": [~34],
		"/soon": [~35],
		"/sticky": [36],
		"/users": [~37],
		"/welcome": [~38],
		"/[entry=entry_slug]": [~6]
	};

export const hooks = {
	handleError: (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);